import { render } from "./AIOrderRegModel.vue?vue&type=template&id=2404abd1"
import script from "./AIOrderRegModel.vue?vue&type=script&lang=js"
export * from "./AIOrderRegModel.vue?vue&type=script&lang=js"

import "./AIOrderRegModel.vue?vue&type=style&index=0&id=2404abd1&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__